<nav class="nav" [class.expanded]="isExpanded()">
  <div class="nav-header">
    @if (logoIconPath()) { @if (logoIconType() === 'vector') {
    <app-svg-icon [path]="logoIconPath()" class="logo-svg-container" />
    } @if (logoIconType() === 'raster') {
    <img [src]="logoIconPath()" />
    } } @if (isExpanded()) {
    <span class="logo-text">{{ logoText() }}</span>
    }
  </div>
  <div class="nav-body">
    @for (item of items(); track item.id) { @if (item.type === "section") {
    <div class="nav-section-lbl">@if (isExpanded()) { {{ item.label }} }</div>
    } @if (item.type === "divider") {
    <div class="nav-divider"></div>
    } @if (item.type === "link" || item.type === "group") {
    <div
      class="nav-item-wrapper"
      [class.nav-group]="item.type === 'group'"
      [class.open]="openGroups().has(item.id)"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      (mouseenter)="showFlyout(item.id)"
      (mouseleave)="hideFlyout()"
    >
      <div
        [class.nav-item]="item.type === 'link'"
        [class.nav-group-hdr]="item.type === 'group'"
        [class.active]="isItemActive(item)"
        [class.open]="openGroups().has(item.id)"
        (click)="
              item.type === 'group'
                ? toggleGroup(item.id)
                : handleNavigation(item)
            "
      >
        @if (item.iconType === "url" && item.icon) {
        <app-svg-icon [path]="item.icon"></app-svg-icon>
        } @if (item.iconType === "font") {
        <span class="material-icons">{{ item.icon }}</span>
        } @if (isExpanded()) {
        <span class="nav-lbl">{{ item.label }}</span>

        @if (item.type === "group") {
        <svg
          class="nav-chev"
          [class.open]="openGroups().has(item.id)"
          viewBox="0 0 24 24"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
        } }
      </div>

      @if (isExpanded() && item.children && openGroups().has(item.id)) {
      <div class="nav-children">
        @for (child of item.children; track child.id) { @if (child.type ===
        'divider') {
        <div class="nav-divider"></div>
        } @if (child.type === 'link') {
        <div
          class="nav-child"
          [class.active]="isItemActive(child)"
          (click)="handleNavigation(child)"
        >
          @if (child.iconType === "font") {
          <span class="material-icons">{{ child.icon }}</span>
          } {{ child.label }}
        </div>
        } }
      </div>
      }

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="
              activeFlyout() === item.id && !isExpanded()
            "
        [cdkConnectedOverlayPositions]="getPositions(item)"
      >
        <div
          class="flyout"
          [class.show]="activeFlyout() === item.id"
          [class.nav-label]="!isGroup(item)"
          (mouseenter)="showFlyout(item.id)"
          (mouseleave)="hideFlyout()"
        >
          @if (item.type === "group") {
          <div class="flyout-hdr">{{ item.label }}</div>
          @for (child of item.children; track child.id) { @if (child.type ===
          'divider'){
          <div class="nav-divider"></div>
          }@if (child.type === 'link') {
          <div
            class="flyout-item"
            [class.active]="isItemActive(child)"
            (click)="handleNavigation(child)"
          >
            {{ child.label }}
          </div>
          } } } @else {
          <div class="nav-tooltip-inner">{{ item.label }}</div>
          }
        </div>
      </ng-template>
    </div>
    } }
  </div>
  <div class="nav-footer">
    <button class="nav-toggle" (click)="toggleNav()">
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <polyline points="11 17 6 12 11 7" />
        <polyline points="18 17 13 12 18 7" />
      </svg>

      <span class="toggle-lbl">{{ isExpanded() ? "Collapse" : "Expand" }}</span>
    </button>
  </div>
</nav>
